<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <!-- <el-form-item class="pr-10">
            <el-select
              v-model="queryForm.branchId"
              clearable
              placeholder="请选择公司"
            >
              <el-option
                v-for="item in branchs"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              />
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="请输入关键词"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="left"
        label="公司"
        prop="branch.title"
        show-overflow-tooltip
        width="160px"
      /> -->
      <el-table-column
        align="left"
        label="工号"
        prop="people.customId"
        show-overflow-tooltip
        width="160px"
      >
      <template #default="{ row }">
          {{ row.basic.peopleId==='SYSTEM'?'系统':row.people.customId }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="姓名"
        prop="people.name"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="手机号"
        prop="people.tel"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="日志内容"
        prop="text"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建时间"
        prop="created"
        show-overflow-tooltip
        width="200px"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import { getAllBranchs } from '@/api/branch'
  import { getLogList } from '@/api/staff'

  export default {
    name: 'BranchLog',
    data() {
      return {
        moment,
        branchs: [],
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        selectRows: '',
        queryForm: {
          page: 1,
          size: 10,
          keyword: '',
          branchId: '',
        },
      }
    },
    created() {
      this.fetchData()
      this.getBranchs()
    },
    methods: {
      async getBranchs() {
        this.branchs = await getAllBranchs()
        this.branchs.unshift({
          title: '集团',
          branchId: 'group',
        })
      },
      handleSizeChange(val) {
        this.queryForm.size = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      queryData() {
        this.queryForm.page = 1
        this.fetchData()
      },
      async fetchData() {
        this.listLoading = true
        const { list, total } = await getLogList(this.queryForm)
        this.list = list
        this.total = total
        this.listLoading = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .pr-10 {
    padding-right: 10px;
  }
</style>
